import type { ReactNode } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { LanguageSelector } from '../components/LanguageSelector';
import { Logo } from '../components/Logo';
import { ThemeToggle } from '../components/ThemeToggle';
import { useTranslation } from '../i18n';
import { AuthParticles } from './AuthParticles';
import './Auth.css';

export function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="auth-container">
      <ThemeToggle className="auth-theme-toggle" />
      <AuthParticles />

      <div className="auth-shell">
        <aside className="auth-brand">
          <Logo className="huge" />
          <p className="auth-welcome">{t('auth.welcome')}</p>
          <div className="auth-language">
            <LanguageSelector variant="compact" />
          </div>
        </aside>

        <main className="auth-main">
          <Outlet />

          <footer className="auth-legal">
            <Link to="/terms" className="auth-legal-link">
              {t('auth.termsOfService')}
            </Link>
            <span className="auth-legal-sep" aria-hidden="true">
              ·
            </span>
            <Link to="/privacy" className="auth-legal-link">
              {t('auth.privacyPolicy')}
            </Link>
          </footer>
        </main>
      </div>
    </div>
  );
}

interface AuthCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

/** Shared card chrome for login / register / legal pages. */
export function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <div className="auth-box">
      <h2 className="auth-heading">{title}</h2>
      {subtitle ? <p className="auth-heading-sub">{subtitle}</p> : null}
      {children}
    </div>
  );
}
